import { checkEmptyObject } from './common';

export const checkProfile = profile => !checkEmptyObject(profile) && !!profile && !!profile.username;
